import { Paper, TextField } from '@mui/material';

import { includesLowerCase } from '@gozoki/tools';
import { GridColDef } from '@mui/x-data-grid';
import { useState } from 'react';
import SimpleDataGrid from '../../components/containers/SimpleDataGrid';
import { InventoryProductRow } from '../../utils/hooks/useInventoryProductRows';

interface InventoryGridProps {
    isLoading: boolean;
    productRows: InventoryProductRow[];
}

export const InventoryGrid = ({ isLoading, productRows }: InventoryGridProps) => {
    const [search, setSearch] = useState('');

    const stockColumnsDefs: GridColDef[] = [
        {
            field: 'reference',
            headerName: 'Réf',
            flex: 1,
            editable: false,
        },
        {
            field: 'label',
            headerName: 'Libellé',
            flex: 2,
            editable: false,
        },
        {
            field: 'theoricalCountBeforeDelivery',
            headerName: 'Stock théorique',
            flex: 1,
            editable: false,
            valueGetter: (params) => params.row.theoricalCount,
        },

        {
            field: 'inventoryCount',
            headerName: 'Stock relevé',
            flex: 1,
            editable: false,
            renderCell: (params) => {
                return params.row.inventoryCount + params.row.unscannedCount;
            },
        },
        {
            field: 'delta',
            headerName: 'Delta',
            renderCell: (params) => {
                // Delta already accounts for reappro needs in useInventoryProductRows
                const delta = params.row.delta > 0 ? `+${params.row.delta}` : `${params.row.delta}`;
                return delta;
            },
        },
    ];

    const filteredRows = productRows
        .filter((row) => includesLowerCase(row.label, search))
        .sort((a, b) => {
            return Math.abs(b.delta) - Math.abs(a.delta);
        });

    return (
        <Paper>
            <div style={{ display: 'flex', alignItems: 'center', padding: '16px' }}>
                <TextField
                    variant="outlined"
                    label="Recherche"
                    value={search}
                    onChange={(e) => {
                        setSearch(e.target.value);
                    }}
                />
                <div style={{ flexGrow: 1 }} />
            </div>
            <SimpleDataGrid
                columns={stockColumnsDefs}
                rows={filteredRows}
                loading={isLoading}
                checkboxSelection={false}
                pageSizeOptions={[100]}
                sx={{
                    '& .MuiDataGrid-columnHeaderTitle': {
                        whiteSpace: 'pre-line',
                        lineHeight: '1.2',
                        textAlign: 'center',
                        overflow: 'visible',
                    },
                    '& .MuiDataGrid-columnHeader': {
                        overflow: 'visible',
                    },
                    '& .problematic-row': {
                        'backgroundColor': '#ffebee !important',
                        '&:hover': {
                            backgroundColor: '#ffcdd2 !important',
                        },
                    },
                }}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 10,
                            page: 0,
                        },
                    },
                }}
            />
        </Paper>
    );
};
